export const BASE_URL: string = process.env.REACT_APP_PUBLIC_URL ?? "";

export const LOGIN_URL = `${BASE_URL}/login`;
export const APP_URL = `${BASE_URL}/chats`;


export const NLP_PATH = "/nlu";
export const NLP_EDIT_TOPIC_PATH = "/nlu/edit-topic";
export const NLP_SEARCH_TOPIC_PATH = "/nlu/search";
